import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconCog({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<path
				fill="#D8D8D8"
				fillRule="nonzero"
				d="m21.496 14.332-1.366-.797c.036-.284.065-.748.065-1.035s-.03-.75-.065-1.035l1.366-.797c.401-.234.595-.716.463-1.165a10.5 10.5 0 0 0-2.41-4.216 1 1 0 0 0-1.233-.182l-1.364.796a9.8 9.8 0 0 0-1.774-1.036V3.272c0-.471-.32-.88-.774-.99a10.36 10.36 0 0 0-4.808 0 1.015 1.015 0 0 0-.774.99v1.593A9.7 9.7 0 0 0 7.048 5.9l-1.364-.796a1 1 0 0 0-1.233.182 10.5 10.5 0 0 0-2.41 4.216c-.132.45.062.93.463 1.165l1.366.797c-.036.284-.065.748-.065 1.035s.03.75.065 1.035l-1.366.797a1.02 1.02 0 0 0-.463 1.165 10.5 10.5 0 0 0 2.41 4.216c.32.342.83.417 1.233.182l1.364-.796a9.7 9.7 0 0 0 1.774 1.036v1.593c0 .471.32.88.774.99 1.577.376 3.23.376 4.808 0 .454-.11.774-.519.774-.99v-1.593a9.8 9.8 0 0 0 1.774-1.036l1.364.796a1 1 0 0 0 1.233-.182 10.5 10.5 0 0 0 2.41-4.216 1.02 1.02 0 0 0-.463-1.165m-2.743 4.254-1.94-1.132c-1.13.976-1.531 1.222-2.975 1.738v2.264c-.502.105-1.326.19-1.838.19s-1.336-.085-1.838-.19v-2.264c-1.408-.503-1.816-.737-2.975-1.738l-1.94 1.132a9.2 9.2 0 0 1-1.84-3.216l1.94-1.132c-.273-1.5-.274-1.975 0-3.476L3.407 9.63a9.2 9.2 0 0 1 1.84-3.216l1.94 1.133c1.146-.992 1.552-1.23 2.975-1.739V3.544c.502-.105 1.326-.19 1.838-.19s1.336.085 1.838.19v2.264c1.423.508 1.829.747 2.975 1.739l1.94-1.133a9.2 9.2 0 0 1 1.84 3.216l-1.94 1.132c.274 1.5.274 1.975 0 3.476l1.94 1.132a9.2 9.2 0 0 1-1.84 3.216M12 8.436c-2.217 0-4.021 1.823-4.021 4.064S9.783 16.565 12 16.565s4.021-1.824 4.021-4.065S14.217 8.435 12 8.435m0 6.774c-1.478 0-2.68-1.216-2.68-2.71S10.521 9.79 12 9.79s2.68 1.216 2.68 2.71-1.202 2.71-2.68 2.71"
			/>
		</svg>
	);
}
